<template>
	<div>
		<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css" integrity="sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N" crossorigin="anonymous">
		<meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
		
		
		<div class=" col-md-6 col-12 p-0">

			<div class="col-12 row mx-0 px-3 py-2" style="background-image: linear-gradient(rgb(0, 145, 165), rgb(1, 136, 154), rgb(2, 126, 144), rgb(3, 117, 133), rgb(3, 108, 123));color:#ffffff;">
				<h3><strong>{{msglist[$route.params.language][1]}}</strong></h3>
				<div class="ml-auto"><router-link :to="{ name: 'my-kh', params: { language: $route.params.language }}">
          			<button class="btn btn-primary" style="font-size: 15px; border-radius: 5px;">{{msglist[$route.params.language][13]}}</button><!--KH 設定-->
          		</router-link></div>
			</div>
		
		<div v-if="serial.startsWith('KH2')" class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);font-size: 1.2rem;font-weight: bold"> 
			<div class="col-12"> {{msglist[$route.params.language][15]}} <!--方式:-->
				<select  v-model=Calmode style="font-size: 1.2rem;font-weight: bold"
						name="Calmode">
						<option value="0" selected="selected">{{msglist[$route.params.language][16]}}</option> <!--0.以魚缸海水校正KH-->
						<option value="1">{{msglist[$route.params.language][17]}}</option>   <!--1. 以標準溶液校正KH-->
				</select>
				<div v-if="Calmode =='0'" class="col-12 px-0">{{msglist[$route.params.language][19]}}</div>
			</div>
		</div>
		<div v-if="Calmode =='1'" class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);font-size: 1.2rem;">
			<div class="col-12 font-weight-bold">{{msglist[$route.params.language][7]}}</div>
		  		<div class="col-12 row mx-0 mt-2">
			  			<div class="" style="width:25px">1.</div>
				  		<div class="col px-0">{{msglist[$route.params.language][11]}}</div>
		  		</div>
		  		<div class="col-12 row mx-0 mt-2">
			  			<div class="" style="width:25px">2.</div>
				  		<div class="col px-0" style="color:blue;">{{msglist[$route.params.language][21]}}.</div>
		  		</div>
		  	</div>
		<div v-if="Calmode =='0'" class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);font-size: 1.2rem;">
		  		<div class="col-12 row mx-0">{{msglist[$route.params.language][20]}}</div>	
			<div class="col-12 font-weight-bold">{{msglist[$route.params.language][7]}}</div>
		  		<div class="col-12 row mx-0">
			  			<div class="" style="width:25px">1.</div>
				  		<div class="col px-0">{{msglist[$route.params.language][8]}}</div>
		  		</div>
		  		<div class="col-12 row mx-0 mt-2">
			  			<div class="" style="width:25px">2.</div>
				  		<div class="col px-0">{{msglist[$route.params.language][9]}}</div>
		  		</div>
		  		<div class="col-12 row mx-0 mt-2">
			  			<div class="" style="width:25px">3.</div>
				  		<div class="col px-0">{{msglist[$route.params.language][10]}}</div>
		  		</div>
		  		<div class="col-12 row mx-0 mt-2">
			  			<div class="" style="width:25px">4.</div>
				  		<div class="col px-0">{{msglist[$route.params.language][11]}}</div>
		  		</div>
		  		<div v-if="serial.startsWith('KH2')" class="col-12 row mx-0 mt-2">
			  			<div class="" style="width:25px">2.</div>
				  		<div class="col px-0" style="color:blue;">{{msglist[$route.params.language][21]}}.</div>
		  		</div>
				<div class="col-12 row mx-0 mt-2">
			  			<div class="" style="width:25px">5.</div>
				  		<div class="col px-0">{{msglist[$route.params.language][12]}}.</div>
		  		</div>
		  	</div>

			  <div v-if="Calmode =='0'" class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
		  		<div class="col-12 px-0 row mx-0">
		  				<div class="col-auto align-self-center"><img style="width:65px;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAJO0lEQVR4nO2daYwcxRXH/zvv7Q42EHBYMDE4wRiBxSWBQQ6I+ybcURTAH7jF5SCUQAKIm3Am5pRwSCCw3MIQYu7DGDCHOc1hIAYbQ3AAgwGjBXMtu+voideo/Fw9072zfUz3/KX6MN1T/arq113V9epooKWWWmqppZYSEjNPYObJcQIRXYMmEBGd46T7956/VIjocpO/LTXu1cGxSqVyQA0bFzhxJzScaGbuYuYlMcNCNIGI6Eknzbd5zv/Z5OtOAG1yjpk/Co7L/2rYeMGJ39VwossKhIj2YOY+p9D/A+AnwfnMgABYHsAwN7iQiOgNex7AymhiINVqdRQzL3LOLapWq+u4cbME4jPydycxs0L+NqS9vf3IIABoJ6LdiehvUnfrdbYPzhPRzib+CBO/wxqoVqujmflkSQ8RTWLm3wEY3iCQ5YhopnO8T9Jt4zYjkNXcaoyI/ur8/p9m6nrn2O3Gxg5ufLe6kKhEdIlbpThhcaVSOWigQLSxdq93ii9u0wMx4b+NACGiK+q0YXJX7xAXSKVSGW+uc0fQiBcSCBHNkDtQ7u6BAmlvb9/ENLYTAfxMq697nePPxgFCRM8zc7dj830AK4TFdYEw8zfa5vhCb16BnObJVGwg9ENVFdh+0dzBw02c4TGeEBv6iWi7iECihlwB+eUgAZnhHJ/qNvwSmPlr5/y2DQCRvL0NYGgEIB/KzeELzPxV0YG8G/WOJKJ9YgL51jbqRHRpUduQwQIyzzn+mfyuEXaJAaSXiPaTKpCIpjvH+wJ3SRmAdBm3RF0gzPyYc/wmNCAD5Ef7HR0d62lDHeRxtvRPCg+EiM51rjNHnHnBOWY+PgTISc7xHmbexlx2pKRP+o2NuE7kJcRUXRcWHoh97yei6ZJxZp4ibzk+IABWYuYFzrnvpbojovOY+UZm/kKP3xrWh4joXBTPwixjZ7NCAxE/GTO/F9Iod4cAkcIYx8yf1mnQz2/U26t2ek1eO/II5NKg40NET4X8rdN0kH68u1xJfU1ETzhPRC8z38/Mm7vxAaxoov6ciP7JzJ+7DbAUMhHtFSUfaifIx7UheZ1o8nGCHn/LOXZqDRuPOjYmoYm0inpUV4oZjwCsKT31sD5DSy211JJf0vDuD+BKAHcBmFqScBMAadjH1XuzS0vSaTodwBcAlpQ8zASwfZYwVgfwTA4KYkmOQh+Ak7OAIePtL4ckaAGAeSUJX4aA+UPaQP5hErAYwKn61JRJbQC2APCgKY9eAN7+VxIaowYD490AxqLcagNwsYHySFrGzzOGI00sKIEqAGY45dIvXoU0DM90jH7oempbwn7mZpVpTInrU8fgv1oQltKqBojUJomr3zEojXtLS7clLpCrkIJcgzIg1FLG5ZO2wTYA4g3+FYDjAFyu7plpAGQ60FwAHwF4D8Br2rA+DOBGAOfoS8eWKc47LhyQihag9HjvMW1Wo73o1zXNAmkNJKNCACEAW+nd/0GKrg6ZwX8WgHUxeGpqIKurc/KDmAXZr0/OW+a4jDDOV89B3OtJR25fvTnyUj6pGdwQwM0AvqtTUL3aLshSuaMB7AjgF6bvE5aeIQA2BvBrdevcrW1NPTgyIfzEBkYhmwqI9Fy7jOtliQnisJNx7t9EHNaNm54x6vybXgeMPLVHyfB4EYHI3XYRgG8i3KHdnokNg50e0RERqzOpFndPIT0DVlyD2+qraVjh/wXAZeb4sQmmJ9ArTrweHfF8uAaYLl22l1R6BqyoBofqkG5/SLV0plMlDTftyRsxhkQHUgBbm3iTnXObAngoBIr47vZMID0NKYpBaXhf8mSoX90tvnGTm81/pQGPovlOnGXWooToNmPLTksV7aL9Fl8ezq3hVM0dEFlS9oknI7P1zgzTFub//46YHim4F7SQ3fWIYRqhVVRg59Ua/+3QJ/lbT37uC+n95wqIvGJ+70n8FXYWeQTX/qKE0v/bAbjIN9Jq1ObrTc+bYK6ATDPnFyukqNrLaXNk4WUSWssZC58To7+xvPrHLBR5GcgtkAs9/qPDY15/M4W4zPr0QdTaAGSfkp/GiCPgHjX5kxeR9fIMpB3AnZ5G8Bg0t4Z6nn7p3Po2n8kVkCJCGRoDRi6BhEGR6utQNJeW81RTPXXaxVwCCYPytSzoQfPoxJgwcg3EB0WekpExbB2oI4EztP+Qts6OCSP3QAIoE3W4VYZg42hh2pkzWgWALNt+GsCuEePkHkgjetP0aZphP65CAznJ2Dse+VehgXSaMZS5TTBTstBARDcYm3YHuryp8EDGDdALnJUKDwTqXnd7yTLekleVAshhxq4MEOVVpQAyxMxgXBhlk5mMVAog0M6la3s88qnSABmtrpfAdtheK1mrNEBEDxj7MkMkbyoVkD0zth9FpQJSAfCOY/+riJPX0lSpgDSDf6t0QDqNf2tOXjZ+KSsQ0fUmHTshPyodkBEALvEMDc/X/Vce1OlIu+pcqrRVCiBtOoluesjk7bDwpc6alD5MWio8kA0APBkDgi/06EZjabhbCg1kvFZHvkLucyZATNGqSrZz/awGmJcSXH1beCCHhFRPU3V+12o1qrexurrWt5hU2ppRCaa7kED29cyifzlkHUc9L/GfPE/Z3AQnTBQOyFq61M21c3XE5QxhktW4b5tr3oICAnk/gZ0+5xkbsjHYYGgNz1rHJxJIf6ZAkg5TBrkXPiblHVQLBWRRnG8TxtBxRQbSndBun0/FbMA7YyzwadONxWYnlPZMgWQ9HrGjM920R1fyynzcLFVaIOuH7AwxLWPvb2mBXFOj7k5tz1yPSgvk8RpAZF1JViotkEk1gEhHMCvlEsimus78ogZ72LU0OmSjsqU+wzfIipKvXAJx3RR/TDAtm2hvW9aLf6y7CiX5+aMo+colENfLekYKaWKkoyj5yhRI2EbKsobjOQC3DuBjX3lWlHylDuRzx+Ay3wAsuYYZIEt9JTQpzXIMvpuGwSbSbgbIhDSM2hkfe6dhtElkP+xiN6ZJRGPN0OoC3V2n7DrBwJC2JjVNNsZlB7mDc7yIJkmN1G1tbX8o1S+2dZpJz+48qOdy8H3BqSmEaerC903EkI5j6lpX59WGuS/KGq7Mci39MH3X9u2zWLYwP0/L7EapK+FunYw2rwRhjs6ovE63RW/IZ/d/0xAwITVWsNQAAAAASUVORK5CYII="></div>
							<div class="col border-left align-self-center">
				  			<div class="col-12 px-0 font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][2]}}</div>
							<div class="px-0 row mx-0 align-self-center" style="width:160px">
								<input v-model="trueKH" min="0" max="20" step="0.1" type="number" @input="limitKH" class="col form-control text-center" name="TrueTankKH_value" style="font-size:1.2rem; font-weight: bold">
								<span class="col-auto px-2 align-self-center">dKH</span>
							</div>
							<div class="col-12 px-0 pb-2"> {{msglist[$route.params.language][18]}} </div>
		  				</div>
		  		</div>
		  	</div>
			
			<div class="col-12 row mx-0 px-0 py-3 mb-1 justify-content-center" style="background: rgb(242, 242, 242);">
		  			<button  v-if="name!=='khacra'" @click=apply name="TrueTankKH_button" :disabled="disabled" class="btn btn-primary" style="min-width: 150px;">{{msglist[$route.params.language][3]}}</button>
					  <div class="col-auto" style="color:red;"><strong>{{message1}}</strong> </div>
			</div>
		
	</div>
</div>

</template>
<script>
//import Log from 'loglevel';
import has from 'lodash/has';

import {
	mapLang
} from "../routes.js";


const mlist = {
	'en': [
		'Applied',
		'Calibrate KH now',
		'True Tank KH',
		'Apply',
		'No KH calibration (keep it blank or 0)',
		'Hit "Apply" to perform calibration based on true tank KH input',
		'Select "SYNC" on KHA LCD to take effect immediately',
		'Steps:',
		'Take tank seawater as sample',
		'Measure the "actual" KH value of the tank seawater using a test kit you trust. The typical margin of error for most test kits is around 0.3 to 0.6.',
		'Enter the "true" tank KH in the box below, then click "Apply"',
		'Select [SYNC] on KHA LCD to calibrate immediately.',
		'The calibration will be finished after half hour.',
		'My KH',
		'Error',
		'Method:',
		'Calibrate by tank seawater',
		'Calibtrate by calibration solution',
		'Input "0" means not calibrate',
		'Both Tank & calibration solution',
		'Match Ref water in box to tank to cut calibration.',
	    'When KHA operates to A6 CAL2 or CAL3, the calibration liquid enters the right test tube. You can press any key to exit and select [pump] to calibrate the water levels of test tubes.'],
	'vi': [
	 	'Đã Áp Dụng',
		'Hiệu chỉnh KH ngay bây giờ',
		'Mục Tiêu KH Trong Bể',
		'Áp Dụng',
		'Không có hiệu chuẩn KH (để trống hoặc 0)',
		'Nhấn "Áp dụng" để thực hiện hiệu chuẩn dựa trên đầu vào KH thực của bể',
		'Chọn “SYNC” trên KHA LCD để có hiệu lực ngay',
		'Các Bước:',
		'Lấy nước biển trong bể làm mẫu',
		'Đo giá trị KH "thực tế" của nước biển trong bể bằng bộ kiểm tra mà bạn tin cậy. Biên độ sai số điển hình của hầu hết các bộ xét nghiệm là khoảng 0,3 đến 0,6.',
		'Nhập bình KH “đúng” vào ô bên dưới rồi nhấn “Áp dụng”',
		'Chọn [SYNC] trên KHA LCD để hiệu chỉnh ngay lập tức.',
		'Việc hiệu chuẩn sẽ hoàn tất sau nửa giờ.',
		'KH Của Tôi',
		'Lỗi',
		'Phương pháp:',
		'Hiệu chuẩn bằng nước biển trong bể',
		'Hiệu chuẩn bằng dung dịch hiệu chuẩn',
		'Đầu vào "0" có nghĩa là không hiệu chỉnh',
		'Cả bồn chứa và giải pháp hiệu chuẩn',
		'Hãy phù hợp nước trong hộp với bể cá để giảm hiệu chuẩn.',
	    'Khi KHA hoạt động đến A6 CAL2 CAL3, dung dịch hiệu chuẩn vào ống nghiệm bên phải. Bạn có thể nhấn bất kỳ phím nào để thoát và chọn [pump] để hiệu chuẩn mức nước trong ống nghiệm.'],
	'ms': [
		'Applied',
		'Calibrate KH now',
		'True Tank KH',
		'Apply',
		'No KH calibration (keep it blank or 0)',
		'Hit "Apply" to perform calibration based on true tank KH input',
		'Select "SYNC" on KHA LCD to take effect immediately',
		'Steps:',
		'Take tank seawater as sample',
		'Measure the "actual" KH value of the tank seawater using a test kit you trust. The typical margin of error for most test kits is around 0.3 to 0.6.',
		'Enter the "true" tank KH in the box below, then click "Apply"',
		'Select [SYNC] on KHA LCD to calibrate immediately.',
		'The calibration will be finished after half hour.',
		'My KH',
		'Error',
		'Method:',
		'Calibrate by tank seawater',
		'Calibtrate by calibration solution',
		'Input "0" means not calibrate',
		'Both Tank & calibration solution',
		'Match Ref water in box to tank to cut calibration.',
	    'When KHA operates to A6 CAL2 or CAL3, the calibration liquid enters the right test tube. You can press any key to exit and select [pump] to calibrate the water levels of test tubes.'],
	'tw': [
		'已套用',
		'立即校正KH',
		'魚缸真實KH值',
		'套用',
		'不輸入就不校正',
		'要校正，以魚缸真實KH值校正',
		'按KHA LCD 的[Sync]以立即校正',
		'步驟:',
		'取用魚缸海水。',
		'以信任的KH試劑測魚缸水的KH值。試劑誤差約0.3~0.6。',
		'輸入魚缸真實KH值。按"套用"',
		'在KHA LCD上選擇[Sync]同步。',
		'30分後可完成校正。',
		'我的KH',
		'錯誤',
		'方式:',  
		'以魚缸水校正KH',
		'以校正液校正KH',
		'輸入0為不校正',
		'校正液會一起校正',
	    '水盒參考水應與魚缸水一致，以減少校正次數',
	    'KHA運作至A6 CAL2或CAL3時，校正液進入右試管，可按任一鍵跳出，選[pump]校正試管水位'],
	'cn': [
		'已套用',
		'立即校准KH',
		'鱼缸真实KH值',
		'校准',
		'不输入就不校准',
		'要校准，以鱼缸真实KH值校准',
		'按KHA LCD的[Sync]以立即校准',
		'步骤:',
		'取用鱼缸海水。',
		'以信任的KH试剂测鱼缸水KH值。试剂误差约0.3~0.6。',
		'输入鱼缸真实KH值。按"校准"',
		'在KHA LCD上选择[Sync]同步。',
		'30分后可完成校准。',
		'我的KH',
		'错误',
		'方式:',  
		'以鱼缸水校准KH',
		'以校准液校准KH',
		'输入0为不校准',
		'校准液会一起校准',
	    '水盒参考水应与鱼缸水一致，以减少校准次数',
	    'KHA运作至A6 CAL2或CAL3时，校准液进入右试管，可按任一键跳出，选[pump]校准试管水位'],
}


//let PURL = process.env.SERVER;


function startCfg(Vue) {
	let PURL = localStorage.getItem("server") || process.env.SERVER;
	let url = PURL + '/api/v1/KH/start-config';
  let user = JSON.parse(localStorage.getItem("user")) || Vue.$store.getters.user || {};   
  let body = {
      "user": user.name,
      "serial": ''
  };
  let sidx=localStorage.getItem('sidx');  // restore sidx from localstorage after webpage reload or change language
  has(user, 'data.devices') ? body.serial = user.data.devices[sidx] : '';
  Vue.trueKH = String(Vue.trueKH).replace(',', '.'); // Replace ',' with '.' for German. they use 6,3 instead of 6.3 
  if (Vue.Calmode =='1') {Vue.trueKH=0; body['field10'] = 1230;}   // if use standard liquid to calibrate, then set true KH=1.23, KHA will know to use this method
  else {body['field10'] = (Number(Vue.trueKH) * 1000).toFixed(0);}
  /////// update parameters in localstorage ////////
  if (user.trueKH) {
	Vue.$set(user.trueKH, sidx, Number(Vue.trueKH)); // using matrix assignment
	localStorage.setItem('user', JSON.stringify(user));
  }
  // asynch call
  let p1 = Vue.$http.post(url, body);
  Promise.all([p1]).then(([r1]) => {
	  console.log("KH-calibration -- applied");
	  Vue.setMsg(mlist[Vue.getLang()][0] +' !', 5);
  }, reason => {
    let rea=JSON.stringify(reason) ;   
	console.log('server error: ', reason);
	  Vue.setMsg_logout(mlist[Vue.getLang()][14], 2);
  });
}

function fetch10(Vue) {
  let user = JSON.parse(localStorage.getItem("user")) || Vue.$store.getters.user || {};   
  let body = {
    "user": user.name,
    "password": ''
  };

  if (Vue.$route.params.sidx != null) {localStorage.setItem('sidx', Vue.$route.params.sidx);} // when reload webpage, sidx will be forget and = undefined, null
      let sidx=localStorage.getItem('sidx');  // restore sidx from localstorage after webpage reload
	  Vue.serial = user.data.devices[sidx]; // browser use
	  let product = Vue.serial.split('-')[0];

  if (user && user.trueKH) { // if localstorage user && user.trueKH exist, then restore Vue.u parameters from localstorage
		Vue.name=user.name;
	    Vue.trueKH=user.trueKH[sidx]; /// get parameters from localstorage /////
		if (Vue.trueKH == 1.23 && product ==="KH2") {Vue.trueKH=0;Vue.Calmode='1';} // reset display true kh value=0
	    else                                        {Vue.Calmode='0';}
        console.log("KH-calibration -- get parameters from localstorage");
  } else {  
	    let PURL = localStorage.getItem("server") || process.env.SERVER;
	    let urls = PURL + '/api/v1/KH/' + user.data.devices[sidx] + '/' + 'all_field';
		let ps = Vue.$http.post(urls, body);
		Promise.all([ps]).then(([rs]) => {
			if ((rs.status === 200 || rs.status === 204)) {
		Vue.trueKH = rs.data['field10']/1000;
		if (Vue.trueKH == 1.23 && product ==="KH2") {Vue.trueKH=0;Vue.Calmode=1;}
		else                 						{Vue.Calmode=0;}
		console.log("KH-calibration -- get parameters from server");
    }
  }, reason => {
	let rea=JSON.stringify(reason) ; 
    console.log('server error: ', reason);
			Vue.setMsg_logout(mlist[Vue.getLang()][14], 2);
					
  });
      
  }  // if user && user.sleep 

}

export default {
  data: () => {
    return {
      disabled: false,
	  title: "KH Calibration",
	  serial:"",
	  trueKH:"",
	  Calmode: "0",
	  message: "",
	  message1: "",
	  msglist: mlist, 
	  name:"",
	  time_out:""
    }
  },
  created: function () {
    // `this` points to the vm instance
	fetch10(this);
  },
  destroyed: function () {
    //console.log('KH-calibration destroy step');
    //clearInterval(this.time_out);
    clearTimeout(this.time_out);
  },
  computed: {
    alertObject: function() {
        if (this.message) {
            return {"alert": true, "alert-info": true, "alert-warning":true, "alert-danger": false};  // alert-danger 紅色背景 alert-waring 黃色背景
        } else if (this.message.match('error')) {
            return {"alert": true, "alert-danger": true, "alert-info": false};
        } else {
            return {"alert": false, "alert-info": false, "alert-danger": false};
        }
    },
  },
  methods: {
	getLang: function () {
		  //console.log("lang: ", mapLang(), this.$route.params);
		  if (has(this.$route, "params.language")) {
			  return this.$route.params.language;
		  } else {
			  return mapLang();
		  }
	},
    setMsg: function (message, timer) {
        this.message = message;
        // set time in ms
        setTimeout( () => {
            this.message = "";
            this.enable();
        }, timer*1000);
	},
	setMsg_logout: function (message, timer) {  // show message for timer sec and logout
        this.message = message;
        // set time in ms
        setTimeout( () => {
            this.message = "";
            this.enable();
            ////// to complete logout and show login page need this 3 items
            this.$store.dispatch("setUser", {name: '', token: ''});
            this.$auth.destroyToken();
            this.$router.push({ name: 'entry', params: { language: this.$route.params.language } })
        }, timer*1000);
    },      
    apply: function () {
	  //console.log("user start config: ", this.$http, startCfg, this.$store.user);
	  this.message1 = mlist[this.getLang()][6];
      this.disable();  // button disabled
	  startCfg(this);
	  //fetch10(this); // reload field 10 value
    },
	limitKH() {
		if (this.trueKH < 0) this.trueKH = 0;
		if (this.trueKH > 20) this.trueKH = 20;
	},
    enable: function() { this.disabled = false; },
    disable: function() { this.disabled = true; },
  },
  mounted() {
	if (this.$auth.loggedIn()) {
		this.time_out=setTimeout( () => {     // return to my-kh after 5 min
			this.$router.push({ name: 'my-kh', params: { language: this.$route.params.language } })
        }, 600*1000);
        //return this.fillData(1);
		} else {
		  this.$auth.destroyToken();
		  this.$router.push({ name: 'entry', params: { language: this.$route.params.language } })
	  }
  }

}



</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// KH_calibration.vue?825287c6